import {
  AudioPreviewTile,
  AudioPreviewTileProps,
} from "@/components/ui-v2/Tiles/AudioPreviewTile/AudioPreviewTile";
import { TileDeleteButton } from "@/components/ui-v2/Tiles/common/TileDeleteButton";

interface FileSelectPreviewListAudioTileProps extends AudioPreviewTileProps {
  onAction: (event: React.MouseEvent, action: string) => void;
}

export const FileSelectPreviewListAudioTile = (
  props: FileSelectPreviewListAudioTileProps,
) => {
  const { onAction, ...rest } = props;

  return (
    <AudioPreviewTile
      {...rest}
      onAction={onAction}
      slots={{
        bottomLeftEl: TileDeleteButton,
      }}
      slotProps={{
        bottomLeftEl: {
          onAction,
        },
      }}
    />
  );
};
